import { render } from "./EgressRulesTab.vue?vue&type=template&id=cbc1e0d2&scoped=true"
import script from "./EgressRulesTab.vue?vue&type=script&lang=js"
export * from "./EgressRulesTab.vue?vue&type=script&lang=js"

import "./EgressRulesTab.vue?vue&type=style&index=0&id=cbc1e0d2&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.20.2.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbc1e0d2"]])

export default __exports__